export default {
      id: "ic_close_delete-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_close_delete-usage",
      toString: function () {
        return this.url;
      }
    }